<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Employees</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row class="subtitle-2 text--primary mt-1">
          <v-btn color="primary" small to="/new-employee">
            <v-icon left dark>mdi-plus</v-icon>New Employee
          </v-btn>
        </v-row> -->

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="users"
              :search="search"
            >


              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/employees/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import snackbar from "../../../global/snackbar.vue";
export default {
  components: { snackbar },
  data: () => ({
    search: "",
    pageItems: 100,
    rolesDialog: false,
    assignedDialog: false,
    denyDialog: false,
    denyItem: {},
    roleItem: {},
    loader: false,
    record: {},
    headers: [
      { text: "Name", value: "name" },
      { text: "Phone No", value: "phone_number" },
      { text: "Email Address", value: "email" },
      { text: "User Name", value: "userName" },
      { text: "Id No", value: "idNo" },
      // { text: "Edit", value: "action" },
    ],
    roleHeaders: [
      { text: "Name", value: "name" },
      { text: "Edit", value: "action" },
    ],
    users: [],
    userGroups: [],
  }),
  methods: {
    save() {
      if (this.record.RoleId == null || this.record.RoleId == undefined) {
        this.$refs.snackbar.show("Please select group", "red");
      } else {
        const data = {
          role_id: this.record.RoleId,
        };
        const url = `/user/assign-role/${this.record.id}`;
        const self = this;
        this.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.getUsers();
              self.loader = false;
              self.rolesDialog = false;
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/employees`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUsers();
  },
};
</script>